import script from "./app-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./app-layout.vue?vue&type=script&setup=true&lang=js"

import "./app-layout.vue?vue&type=style&index=0&id=2f2fc496&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2fc496"]])

export default __exports__